import React from 'react'
import Loading from "../components/common/Loading";
import switchStyles from "../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import Partners from '@/components/Partners';


const eWayBilling = () => {
    return (
        <>
            <Head>
                <title>Partner Program: Drive Business Growth with QueueBuster</title>
                <link rel="canonical" href="https://queuebuster.co/features/erp" />
                <link rel="alternate" href="https://queuebuster.co/features/erp" hrefLang="en" />
                <meta name="description" content="Join the QueueBuster Partner Program and elevate your business with cutting-edge POS solutions, comprehensive support, and unmatched opportunities for growth." />
                <meta property="og:title" content="Join QueueBuster Partner Program: Boost Your Business with Innovative POS Solutions" />
                <meta property="og:description" content="Become a QueueBuster partner and gain access to industry-leading POS solutions, extensive support, and lucrative opportunities. Collaborate with us to drive your business growth, enhance customer satisfaction, and achieve new heights of success." />
                <meta property="og:image" content="" />
                <meta property="og:url" content="https://queuebuster.co/features/erp" />
            </Head>
            <Partners />
        </>
    )
}

export default eWayBilling